import { Button } from "react-bootstrap";
import { NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { BASE_URL_WEB, DefaultUserProfile } from "../../config/config";
import { List, ListItemButton, ListItemText } from "@mui/material";
import MaterialSymbol from "../icons/material-symbol";
import { usesInfluencerFlow } from "../../modules/influencer/flowUser";
interface Props {
  isLogin: boolean;
  user: any;
  profileMenu: boolean;
  toggleProfile: () => void;
  headerPictureUrl: string;
  getSubscriptionDetail: any;
  setOpenModal: (value: boolean) => void;
  isBasicUser: boolean;
  HeaderMenu: any[];
  accounts: any[];
  handleNavLinkClick: (menu: any) => void;
  listVars: any;
  menuLinkVars: any;
  localService: any;
  validUrls: any;
  agencyUrls: any;
  talentPartnerUrls: any;
  switchLayer2: any;
  headerProfileToggle: any;
  toggles: boolean;
  toggle: () => void;
  guest_user: string;
  user_email_id: string;
  selectedIndex: number;
  handleListItemClick: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => void;

  setToggles: (value: boolean) => void;
  handleNavigation: any;
}
function HeaderRight(props: Props) {
  const {
    isLogin,
    user,
    profileMenu,
    toggleProfile,
    headerPictureUrl,
    getSubscriptionDetail,
    setOpenModal,
    isBasicUser,
    HeaderMenu,
    accounts,
    handleNavLinkClick,
    listVars,
    menuLinkVars,
    localService,
    validUrls,
    agencyUrls,
    talentPartnerUrls,
    switchLayer2,
    toggle,
    toggles,
    guest_user,
    user_email_id,
    setToggles,
    selectedIndex,
    handleListItemClick,
    handleNavigation
  } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const safeAgencyUrls = agencyUrls || [];
  const safeTalentUrls = talentPartnerUrls || [];
  const safeValidUrls = validUrls || [];

  const switchPaths = ["/switch/account", "/switch/user"];

  const isAgency = user?.account_type === "Agency";
  const isTalentPartner = user?.account_type === "Talent Partner";
  const isBrand = user?.account_type === "Brand";
  const isInfluencer = user?.account_type === "Influencer";
  // Influencers, and Talent Partners inside a picked creator (the new influencer flow).
  const influencerFlow = isLogin && usesInfluencerFlow(user, switchLayer2);

  const showLoginSignUp = location.pathname !== "/subscription/invoice";
  const isClanshopUrl = location.pathname.includes("/clanshop");

  const settingsPath = isBrand
    ? "/brand/profile/personal-info" // the new flow's settings (the brand app's)
    : influencerFlow
      ? "/influencer/profile" // the new flow's Profile (the influencer app's)
      : isAgency
        ? "/agency/settings/personal-info"
        : "/talent-partner/settings/personal-info";

  const filteredHeaderMenu = HeaderMenu.filter((menu: any) => menu.id !== 6);

  const showAdminDashboard =
    isAgency &&
    String(user?.view_admin_dashboard) === "True" &&
    safeValidUrls.includes(location.pathname);

  const profileImage =
    isAgency && [...safeAgencyUrls, ...switchPaths].includes(location.pathname)
      ? user?.photo
      : isTalentPartner &&
        ![...safeTalentUrls, ...switchPaths].includes(location.pathname)
        ? user?.photo
        : isTalentPartner &&
          [...safeTalentUrls, "/switch/user"].includes(location.pathname)
          ? switchLayer2?.photo
          : user?.logo_url || headerPictureUrl;

  const menuAnimation = {
    animate: profileMenu ? "open" : "initial",
    exit: "initial",
  };

  const renderHeaderMenu = () =>
    !safeValidUrls.includes(location.pathname) &&
    filteredHeaderMenu.map((menu: any) => (
      <motion.li key={menu.id} variants={menuLinkVars} {...menuAnimation} className="d-lg-none">
        <NavLink
          className="header_links"
          to={
            // Gated for free creators only (handleNavLinkClick shows them the
            // upgrade). Free brands use the new Inbox: the API limits what
            // they can open there (locked proposals, direct chats).
            isBasicUser && ["Profile View", "Inbox"].includes(menu.title) && ["Influencer", "Talent Partner"].includes(user?.account_type)
              ? "#"
              : menu.url
          }
          onClick={() => {
            toggleProfile();
            handleNavLinkClick(menu);
          }}
        >
          <span>{menu.title}</span>
        </NavLink>
      </motion.li>
    ));

  return (
    <>
      {/* =========================
         LOGGED IN USER
      ========================= */}

      {isLogin && (
        <>
          <AnimatePresence>
            <motion.div className={`app-header-brand_right_side ${influencerFlow && " d-none d-md-flex"}`}>
              {/* USER INFO */}
              <div className="header-profile-left">
                <ul className="header-premium">
                  {(isAgency || isTalentPartner) &&
                    [...safeAgencyUrls, ...safeTalentUrls, ...switchPaths].includes(
                      location.pathname
                    ) && (
                      <li>{!!user?.account_name && <span className="header-premium__name">{user.account_name}</span>}</li>
                  )}
                  {(isBrand || isInfluencer) && (
                    <li className={isBasicUser ? "header-basic-user" : ""}>
                      {!!user?.account_name && <span className="header-premium__name">{user.account_name}</span>}

                      {!switchPaths.includes(location.pathname) &&
                        getSubscriptionDetail &&
                        !isBasicUser && <span className="pro-tag ms-2">PRO</span>}
                    </li>
                  )}

                  {!safeValidUrls.includes(location.pathname) &&
                    ((isAgency &&
                      user?.role_name !== "Editor" &&
                      user?.role_name !== "Report") ||
                      isTalentPartner) && (
                      <>
                        <li className={isBasicUser ? "header-basic-user" : ""}>
                          {!!(isAgency ? user?.brand_name : user?.name) && <span className="header-premium__name">{isAgency ? user?.brand_name : user?.name}</span>}
                          {getSubscriptionDetail && !isBasicUser && (
                            <span className="pro-tag ms-2">PRO</span>
                          )}
                        </li>

                        {!switchPaths.includes(location.pathname) &&
                          (isAgency || isBrand) && (
                            <Button
                              className="btn btn-primary btn-let-us-help"
                              onClick={() => setOpenModal(true)}
                            >
                              Let us help you
                            </Button>
                          )}


                      </>
                    )}
                  {!switchPaths.includes(location.pathname) &&
                    <><li>
                      {(user?.account_type === "Brand" || user?.account_type === "Influencer" || user?.account_type === "Talent Partner") && <>

                        {isBasicUser &&
                          <Button
                            onClick={() => handleNavigation(user?.account_type)}
                            variant='contained'
                            className='btn btn-primary btn-let-us-help'
                          >
                            Upgrade
                          </Button>
                        }

                      </>}
                    </li>
                    </>}
                  {(user?.account_type === "Brand") &&
                    <Button
                      variant='contained'
                      className='btn btn-primary btn-let-us-help'
                      onClick={(e) => setOpenModal(true)}>
                      Let us help you
                    </Button>
                  }
                </ul>
              </div>

              {/* PROFILE IMAGE */}

              <span className="_header_profile_picture">
                <img
                  src={profileImage || DefaultUserProfile.influencer_unknown_default}
                  alt="profile"
                  onClick={toggleProfile}
                />

                <ul className="profile_image_toggle" onClick={toggleProfile}>
                  <li />
                  <li />
                  <li />
                </ul>
              </span>

              {/* PROFILE MENU */}

              <AnimatePresence>
                <motion.ul
                  className={`profile_image_menu ${profileMenu ? "active" : ""}`}
                  variants={listVars}
                  initial="initial"
                  animate={profileMenu ? "animate" : "exit"}
                  exit="exit"
                >
                  {showAdminDashboard && (
                    <motion.li variants={menuLinkVars} {...menuAnimation}>
                      <NavLink
                        className="header_links"
                        to="/brand/admin-dashboard"
                        onClick={toggleProfile}
                      >
                        <span>Admin Dashboard</span>
                      </NavLink>
                    </motion.li>
                  )}

                  {renderHeaderMenu()}

                  {(isAgency || isTalentPartner) && (
                    <motion.li
                      variants={menuLinkVars}
                      {...menuAnimation}
                      onClick={() => {
                        toggleProfile();
                        navigate("/switch/user");
                      }}
                    >
                      <span>{isAgency ? "All Brands" : "All Influencers"}</span>
                    </motion.li>
                  )}

                  {/* The new campaign flow's Profile (/brand/profile) — the brand app's Profile tab. */}
                  {(isBrand || isAgency) && (
                    <motion.li variants={menuLinkVars} {...menuAnimation}>
                      <NavLink
                        className="header_links"
                        to="/brand/profile"
                        onClick={toggleProfile}
                      >
                        <span>Profile</span>
                      </NavLink>
                    </motion.li>
                  )}

                  {/* Brands / agencies: their settings are on Profile (the brand app's), so no separate item. */}
                  {!(isBrand || isAgency) && (
                  <motion.li variants={menuLinkVars} {...menuAnimation}>
                    <NavLink
                      className="header_links"
                      to={settingsPath}
                      onClick={toggleProfile}
                    >
                      <span>Settings</span>
                    </NavLink>
                  </motion.li>
                  )}

                  <motion.li variants={menuLinkVars} {...menuAnimation}>
                    <NavLink
                      className="header_links"
                      to={`${BASE_URL_WEB}/faqs`}
                      target="_blank"
                    >
                      <span>FAQ</span>
                    </NavLink>
                  </motion.li>

                  <motion.li variants={menuLinkVars} {...menuAnimation}>
                    <NavLink
                      className="header_links"
                      to={`${BASE_URL_WEB}/privacy_policy/`}
                      target="_blank"
                    >
                      <span className="d-flex align-items-center">
                        Privacy Policy
                        <MaterialSymbol
                          iconName="open_in_new"
                          className="ps-1"
                          fontweight="200"
                          fontSize="16px"
                        />
                      </span>
                    </NavLink>
                  </motion.li>

                  {accounts?.length > 1 && (
                    <motion.li
                      variants={menuLinkVars}
                      {...menuAnimation}
                      onClick={() => navigate("/switch/account")}
                    >
                      <span>Switch Account</span>
                    </motion.li>
                  )}

                  <motion.li
                    variants={menuLinkVars}
                    {...menuAnimation}
                    onClick={() => localService.logout()}
                  >
                    <span>Logout</span>
                  </motion.li>
                </motion.ul>
              </AnimatePresence>
            </motion.div>
          </AnimatePresence>
          {/* <div className={`${user?.account_type === 'Influencer' && " d-md-none w-100"}`}>
          <div className="app-header">
           
            <span className="_header_profile_picture">
              <Link to="/influencer/settings/personal-info">
                <img
                  src={profileImage || DefaultUserProfile.influencer_unknown_default}
                  alt="profile"
                  onClick={toggleProfile}
                />
              </Link>
            </span>

            <div className="icons">
              <button >
                <MaterialSymbol iconName="filter_alt" fontweight="200" />
              </button>
              <NavLink to="/influencer/campaign-msg">
                <span>🔔</span>
              </NavLink>
            </div>
          </div>
        </div> */}
        </>
      )}
      {/* =========================
         PUBLIC USER
      ========================= */}

      {!isLogin && !guest_user && (
        <>
          <nav
            className={`nav-menu mx-auto ${toggles ? "active_header" : ""}`}
            onClick={() => setToggles(false)}
          >
            <List className="p-0 d-lg-none">
              <ListItemButton
                divider
                selected={selectedIndex === 1}
                onClick={(e) => handleListItemClick(e, 1)}
              >
                <ListItemText>
                  <NavLink to="/">Sign Up</NavLink>
                </ListItemText>
              </ListItemButton>

              <ListItemButton
                divider
                selected={selectedIndex === 2}
                onClick={(e) => handleListItemClick(e, 2)}
              >
                <ListItemText>
                  <NavLink to="/login">Login</NavLink>
                </ListItemText>
              </ListItemButton>
            </List>
          </nav>

          <div
            onClick={toggle}
            className={`header-toggle-button ${toggles ? "toggle-active" : ""
              }`}
          >
            <span />
            <span />
            <span />
          </div>
        </>
      )}
      {/* =========================
         GUEST USER
      ========================= */}

      {!isLogin && (
        <>
          {/* <span className="guest_user_avatar">
            <span className="guest_user_pic _header_profile_picture">
              <img
                src={DefaultUserProfile.influencer_unknown_default}
                alt="profile"
              />
            </span>
            <span className="email">{JSON.parse(user_email_id)}</span>
          </span> */}
          {showLoginSignUp &&
            <Link
              to='/request-a-demo'
              className='btn btn-outline-primary btn-rounded ml-auto d-md-flex d-none'
            >
              Request a demo
            </Link>
          }
          <ul className="mobile_view_none">
            <li>
              <NavLink to="/">Sign Up</NavLink>
            </li>
            <li>
              <NavLink to="/login">Login</NavLink>
            </li>
          </ul>
        </>
      )}


    </>
  );
}

export default HeaderRight;